<mat-dialog-content class="mat-typography">
    <h3>Recordá que en el FTyC no financiamos la compra de objetos usados.</h3>
    <p>El presente desarrollo no constituye oferta del FTyC, sólo tiene carácter informativo y orientativo para el
        interesado. Préstamos sujetos a las condiciones de aprobación del FTyC.</p>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: center">
    <button mat-button mat-dialog-close class="boton-rojo-ftyc">Entendido</button>
</mat-dialog-actions>
